module.exports = __webpack_public_path__ + "img/parkingA.24be2521.png";